import React, { useState } from 'react';
import Sidebar from './Sidebar';
import { Outlet } from 'react-router-dom';
import { Menu } from 'lucide-react';

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen bg-stone-50 overflow-hidden font-sans relative">
      <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />
      
      {/* Overlay for mobile when sidebar is open */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 lg:hidden" 
          onClick={() => setSidebarOpen(false)} 
        />
      )}

      <main className="flex-1 overflow-auto bg-stone-50 w-full h-full flex flex-col">
        {/* Mobile Header */}
        <div className="lg:hidden flex items-center justify-between bg-stone-900 text-white p-4 shrink-0">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-full bg-amber-500 flex items-center justify-center font-bold text-stone-900 text-sm">SP</div>
            <h1 className="text-xl font-semibold tracking-tight text-amber-50">Sol Planet</h1>
          </div>
          <button onClick={() => setSidebarOpen(true)} className="p-2 text-stone-300 hover:text-white">
            <Menu size={24} />
          </button>
        </div>

        <div className="p-4 md:p-8 max-w-7xl mx-auto min-h-full w-full">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout;
